export enum EntryDialogResolveStatus {
    Success = 'success',
    Close = 'close',
}
